<!--
  +---------------------------------------------------------------------------------------
  | @Author:    kangpengsen<kangpengsen@frippler.com>
  | @Title:     增值-商品管理-运费模板详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-loading="loading" class="ei-shipping-template flex column align-items-center">
    <div class="content">
      <div class="main-header">
        <div class="title">
          <f-back />
          <span v-if="shippingTemplate.templateid">{{ $route.meta.title }}</span>
          <span v-else>运费模板详情</span>
        </div>
      </div>
      <el-card shadow="never">
        <el-form
          ref="FromRef"
          :show-message="false"
          class="card-form"
          :model="shippingTemplate"
          :rules="rules"
          hide-required-asterisk
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="shippingTemplate.name" class="shipping-input" placeholder="请输入模板名称" clearable />
          </el-form-item>
          <el-form-item label="发货时效">
            <el-select v-model="shippingTemplate.delivery_time_type" class="shipping-input">
              <el-option v-for="item in delivery_time_type_list" :key="item.id" :label="item.value" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="运费计算">
            <div class="default mb-md">
              默认
              <f-number-unit v-model="defaultShipping.first_num" :min="1" :step="1" step-strictly unit="件"/>
              以内，运费
              <f-number-unit v-model="defaultShipping.first_price" :min="0" unit="元"/>
              ，每增加1件，增加运费
              <f-number-unit v-model="defaultShipping.second_price" :min="0" unit="元"/>
            </div>
            <div class="designated-area radius10 pl pr pb">
              <div class="designated-area-title flex justify-content-space-between align-items-center">
                <span>指定地区运费（选填）</span>
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addColumn">添加地址</el-button>
              </div>
              <el-table :data="tableData" :show-header="false">
                <el-table-column prop="date" label="地区" width="200">
                  <template slot-scope="scope">
                    <el-form :ref="'Form' + scope.row.idx" :model="scope.row" :rules="rules">
                      <el-form-item prop="areas">
                        <f-area-multiple-picker
                          v-model="scope.row.areas"
                          :disabled-options="disabledOptions"
                          @change="areaChange"
                          @remove-tag="removeTag"
                        />
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <f-number-unit v-model="scope.row.first_num" :min="1" :step="1" step-strictly unit="件"/>
                    以内，运费
                    <f-number-unit v-model="scope.row.first_price" :min="0" unit="元"/>
                    ，每增加1件，增加运费
                    <f-number-unit v-model="scope.row.second_price" :min="0" unit="元"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="50">
                  <template slot-scope="scope">
                    <el-link :underline="false" class="font-lg" @click="deleteColumn(scope)"><i
                      class="el-icon-delete"></i></el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item prop="no_send_area">
            <template slot="label">
              不配送地区
              <el-tooltip
                class="item"
                effect="dark"
                content="暂不支持配送港澳台及境外地区，如果收货地址在不配送地区内，将无法购买商品"
                placement="bottom-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <f-area-multiple-picker
              v-model="shippingTemplate.no_send_area"
              class="f-area-multiple-picker"
              width="320px"
              :disabled-options="defaultDisabledOptions"
              type="selectedDisabled"
              placeholder="选择地区（选填）"
            />
          </el-form-item>
        </el-form>
        <div class="footer flex align-items-center">
          <el-button @click="back">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { addShippingTemplateApi, getShippingTemplateDetailApi } from "@/api/ei/eiMallApi"

export default {
  name: "EiShippingTemplate",

  data() {
    const validateArea = (rule, value, callback) => {
      const val = Array.isArray(value) && value[0] && value[0][0]
      if (!val) {
        callback(new Error('请选择地区'))
      } else {
        callback()
      }
    }
    const commonDisabledOptions = ["澳门特别行政区", "台湾省", "香港特别行政区"]
    return {
      loading: false,
      delivery_time_type_list: [],
      defaultShipping: {
        first_num: 1,
        first_price: 0,
        second_num: 1,
        second_price: 0,
        is_default: 1,
        areas: []
      },
      shippingTemplate: {
        templateid: Number(this.$route.query.templateid) || 0,
        name: '',
        delivery_time_type: 2,
        valuation_type: 1,
        freight_calc_method: [],
        no_send_area: [["澳门特别行政区"], ["台湾省"], ["香港特别行政区"]]
      },
      tableData: [],
      defaultDisabledOptions: [...commonDisabledOptions],
      disabledOptions: [...commonDisabledOptions],
      rules: {
        name: [
          { required: true, message: '请输入运费模板名称', trigger: 'blur' }
        ],
        areas: [
          { validator: validateArea, trigger: 'blur' }
        ]
      }
    };
  },

  computed: {},

  watch: {},

  created() {
    if(Number(this.shippingTemplate.templateid)) {
      this.fetchData()
    }
    this.delivery_time_type_list = this.$store.state.eiStore.deliveryTimeTypeArr
  },

  methods: {
    areaChange(val) {
      const newRes = val.newVal.map(item => {
        return item[0]
      })
      const oldRes = val.oldVal.map(item => {
        return item[0]
      }).filter(item => item !== undefined)

      let newDisabledOptions = []
      if(newRes.length > oldRes.length) {
        // newRes长度大于oldRes，说明有新增的地区
        newDisabledOptions = [...this.disabledOptions, ...this.defaultDisabledOptions, ...newRes]
      } else {
        // newRes长度小于oldRes，说明有删除的地区
        newDisabledOptions = this.disabledOptions.filter(option => !val.diffVal.map(item => item[0]).includes(option))
      }

      this.disabledOptions = [...new Set(newDisabledOptions)]

    },
    addColumn() {
      this.tableData.push({
        first_num: 1,
        first_price: 0,
        second_num: 1,
        second_price: 0,
        areas: [],
        idx: this.getRandom(),
        is_default: false
      })
    },

    deleteColumn(scope) {
      this.setDisabledOptions(scope.row.areas)
      this.tableData = this.tableData.filter((item, index) => index !== scope.$index)
    },

    removeTag(val) {
      this.setDisabledOptions(val)
    },

    // removeTag和deleteColumn用到的设置禁用项
    setDisabledOptions(val) {
      const res = val.map(item => {
        return item[0]
      })
      this.disabledOptions = this.disabledOptions.filter(option => !res.includes(option))
    },

    submit() {
      let validCheck = true
      this.$refs.FromRef.validate((valid) => {
        if (!valid) validCheck = false
      })
      const formArr = Object.keys(this.$refs)
      for (let i = 0; i < formArr.length; i++) {
        if (this.$refs[formArr[i]] && formArr[i].indexOf('Form') === 0) {
          this.$refs[formArr[i]].validate((valid) => {
            if (!valid) {
              validCheck = false
            }
          })
        }
      }
      if (validCheck) {
        const loading = this.$loading({
          text: `正在保存...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const template = {...this.shippingTemplate}
        const freight_calc_method_arr = this.tableData.map(item => {
          return {
            ...item,
            areas: item.areas.map(item => {
              return {
                province: item[0],
                city: '',
                district: ''
              }
            })
          }
        })
        template.freight_calc_method = [...freight_calc_method_arr, this.defaultShipping]
        template.no_send_area = this.shippingTemplate.no_send_area.map(item => {
          return {
            province: item[0],
            city: '',
            district: ''
          }
        })
        addShippingTemplateApi(template).then(res => {
          loading.close()
          if (!res.errno) {
            this.$message.success('保存成功!')
            this.back()
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
          loading.close()
        })
      }
    },

    back() {
      this.$router.go(-1)
    },

    fetchData() {
      this.loading = true
      this.tableData = []
      getShippingTemplateDetailApi({templateid: this.shippingTemplate.templateid}).then(res => {
        if (!res.errno) {
          this.shippingTemplate = res.data
          res.data.freight_calc_method.forEach(item => {
            this.disabledOptions.push(...item.areas.map(item => item.province))
            if (item.is_default) {
              this.defaultShipping = {
                ...item,
                areas: item.areas.map(item => {
                  return [item.province]
                })
              }
            } else {
              this.tableData.push({
                ...item,
                idx: this.getRandom(),
                areas: item.areas.map(item => {
                  return [item.province]
                })
              })
            }
          })
          this.disabledOptions = [...new Set(this.disabledOptions)]
          this.shippingTemplate.no_send_area = res.data.no_send_area.map(item => {
            return [item.province]
          })
        }
        this.loading = false
      })
    },

    // 获取随机数
    getRandom() {
      return new Date().getTime() + Math.random().toString(36).slice(2, 11)
    }
  }
};
</script>

<style lang="scss" scoped>
.ei-shipping-template {
  height: calc(100vh - 60px);
  .content {
    width: 1100px;
    height: 100%;
    .el-card {
      height: calc(100% - 60px);
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 20px 0 0;
        overflow: hidden;
      }
      .card-form {
        flex: 1;
        padding: 0 20px;
        overflow: auto;
        .el-form-item {

          .default {
            line-height: inherit;
          }

          .shipping-input {
            width: 180px;
          }

          .designated-area {
            background-color: #EEF0F550;

            .designated-area-title {
              height: 60px;
              color: #909399;
              border-bottom: 1px solid #dcdfe6;
            }

            .el-table {
              background-color: transparent;

              /deep/ tr {
                background-color: transparent;

                td {
                  border: none;
                }
              }
            }
          }
        }
      }

      .footer {
        justify-content: end;
        padding: 20px;
        border-top: 1px solid #dcdfe6;
        height: 80px;

        .el-button {
          width: 90px;
        }
      }
    }
  }
}
</style>
